import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { MyNotificationsPage } from '@/features/preparer/notifications/MyNotificationsPage';

/**
 * Search params schema for sticky filtering/pagination
 */
const notificationsSearchSchema = z.object({
  // Tab selection (all, unread, read)
  tab: z.enum(['all', 'unread', 'read']).optional().catch(undefined),
  // Pagination
  page: z.number().int().positive().optional().catch(undefined),
  pageSize: z.number().int().positive().optional().catch(undefined),
  // Filters
  clientId: z.string().optional().catch(undefined),
  actionType: z.string().optional().catch(undefined),
  dateFrom: z.string().optional().catch(undefined),
  dateTo: z.string().optional().catch(undefined),
  // Notification settings dialog
  settings: z.literal('open').optional().catch(undefined),
});

export const Route = createFileRoute('/preparer/notifications/')({
  component: MyNotificationsPage,
  validateSearch: notificationsSearchSchema,
});
